import { z } from 'zod';
export const SubmitQuestionRequestSchema = z.object({
    sessionId: z.string().uuid(),
    body: z.string().min(5).max(800),
});
export const ModerateQuestionRequestSchema = z.object({
    status: z.enum(['approved', 'hidden', 'answered']),
});
export const CreatePollRequestSchema = z.object({
    sessionId: z.string().uuid(),
    type: z.enum(['multiple_choice', 'word_cloud']),
    question: z.string().min(1).max(400),
    options: z.array(z.string().min(1).max(80)).optional(),
});
export const RespondPollRequestSchema = z.object({
    choice: z.string().min(1).max(80).optional(),
    text: z.string().min(1).max(400).optional(),
});
export const ReactionRequestSchema = z.object({
    sessionId: z.string().uuid(),
    type: z.string().min(1).max(40),
    count: z.number().int().min(1).max(10),
});
export const SubmitPhotoRequestSchema = z.object({
    storagePath: z.string().min(1),
    caption: z.string().max(400).optional(),
});
export const ModeratePhotoRequestSchema = z.object({
    decision: z.enum(['approve', 'hide']),
});
export const PublishAnnouncementRequestSchema = z.object({
    title: z.string().min(1).max(200),
    body: z.string().min(1).max(2000),
    severity: z.enum(['info', 'important', 'urgent']),
});
export const RegisterPushTokenRequestSchema = z.object({
    token: z.string().min(10).max(2048),
    platform: z.enum(['ios', 'android', 'web']),
});
//# sourceMappingURL=live.js.map